import React from 'react';
import '../styles/Hero.css';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">
            Building Tomorrow's
            <span className="highlight"> Software Solutions</span>
          </h1>
          <p className="hero-description">
            Tallhaven is a leading software development company that creates innovative, 
            scalable solutions for businesses worldwide. From web applications to mobile apps, 
            we bring your digital vision to life.
          </p>
          <div className="hero-buttons">
            <a href="#services" className="btn btn-primary">Our Services</a>
            <a href="#contact" className="btn btn-secondary">Get In Touch</a>
          </div>
        </div>
        <div className="hero-visual">
          <div className="code-window">
            <div className="window-header">
              <div className="window-controls">
                <span className="control red"></span>
                <span className="control yellow"></span>
                <span className="control green"></span>
              </div>
              <span className="window-title">Tallhaven.js</span>
            </div>
            <div className="code-content">
              <pre>
{`const tallhaven = {
  mission: 'Innovative Software',
  expertise: ['React', 'Node.js', 'Python'],
  clients: 'Worldwide',
  quality: 'Premium'
};

console.log('Building the future...');`}
              </pre>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;